function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19865",
    transform: "translate(-487 -177)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 625",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(487 177)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16314",
    d: "M2.9 11.692a.732.732 0 0 0-.2.408l-.689 4.8a.728.728 0 0 0 .828.828l4.8-.689a.732.732 0 0 0 .411-.205l5.659-5.652L8.553 6.04z",
    transform: "translate(494.146 183.112)",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16315",
    d: "m13.21 3.054-.85.85 5.146 5.146.858-.85c3.4-3.414-1.755-8.545-5.153-5.146z",
    transform: "translate(491.38 184.207)",
    style: {
      fill: "#bababa"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRound);
export default __webpack_public_path__ + "static/media/edit-round.ebbad2348f49411607eb1460c4bb436a.svg";
export { ForwardRef as ReactComponent };